<template>
  <div>
    <Header></Header>
    <Main></Main>
    <Footer></Footer>
    <Vlevator></Vlevator>
  </div>
</template>

<script setup>
import Header from "@/layouts/header/index.vue"
import Main from "@/layouts/main/index.vue"
import Footer from "@/layouts/footer/index.vue"
import Vlevator from "@/components/elevator/index.vue"

import { ref, provide, onMounted, onBeforeUnmount } from 'vue'
import { useRoute } from 'vue-router'

const pages = ref([])
const currentIndex = ref(0)
let isScrolling = false

provide('pageController', {
  register(pagesList) {
    pages.value = Array.from(pagesList)
    currentIndex.value = 0
  },
  scrollTo(index) {
    if (!pages.value[index]) return
    pages.value[index].scrollIntoView({ behavior: 'smooth' })
    currentIndex.value = index
  },
  currentIndex
})
onMounted(() => {
  window.addEventListener('wheel', onWheel, { passive: false })
})

onBeforeUnmount(() => {
  window.removeEventListener('wheel', onWheel)
})
const onWheel = (e) => {
  if (!pages.value.length) return

  const vh = window.innerHeight
  const scrollTop = window.scrollY

  //  最后一屏真正的底部
  const lastPage = pages.value[pages.value.length - 1]
  const lastPageBottom = lastPage.offsetTop + vh
  //  一旦进入 footer
  if (scrollTop + window.outerHeight >= lastPageBottom - 1) {
    isScrolling = false
    return
  }

  //  找到当前所在的 page
  const currentPageIndex = pages.value.findIndex(page => {
    const top = page.offsetTop
    return scrollTop >= top && scrollTop < top + vh
  })

  // 不在 page 区域，放权
  if (currentPageIndex === -1) return

  e.preventDefault()
  if (isScrolling) return
  isScrolling = true

  const nextIndex =
    currentPageIndex + (e.deltaY > 0 ? 1 : -1)

  if (!pages.value[nextIndex]) {
    isScrolling = false
    return
  }

  pages.value[nextIndex].scrollIntoView({ behavior: 'smooth' })

  setTimeout(() => (isScrolling = false), 900)
}
</script>
<style lang="scss" scoped>
::v-deep .el-dialog__header {
  padding: 0 !important;
}

::v-deep .el-input {
  --el-input-focus-border-color: #46776D;
  /*鼠标悬停边框颜色*/
  --el-input-hover-border-color: #46776D;
}

::v-deep .el-checkbox__input.is-checked .el-checkbox__inner {
  border-color: #46776D;
  background-color: #46776D;
}

::v-deep .el-checkbox__inner:hover {
  border-color: #46776D !important;
}
</style>